<div class="open-project-add-dialog">
  <small class="p-text-secondary">
    Select one or more projects to add to Open Project. Projects already in Open Project are disabled.
  </small>

  <div class="dialog-grid-wrapper">
    <ag-grid-angular
      class="ag-theme-alpine"
      style="width: 100%; height: 100%;"
      [loading]="loading"
      [localeText]="localeText"
      [rowData]="projects"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>

  <div class="dialog-actions">
    <span class="p-text-secondary">Selected: {{selectableSelectedCount}}</span>

    <span>
      <button pButton
              type="button"
              class="p-button-sm p-mr-2"
              icon="pi pi-plus"
              label="Add to Open Project"
              [disabled]="adding || selectableSelectedCount === 0"
              (click)="addSelectedProjects()"></button>

      <button pButton
              type="button"
              class="p-button-sm p-button-outlined"
              icon="pi pi-times"
              label="Close"
              (click)="closeDialog()"></button>
    </span>
  </div>
</div>
